export const VERSION_NUMBER = '1.110';
export const BUILD_TIME = '';
export const BUILD_NOTES =
    '<ul><li>Added new role for individuals that are allowed to edit/update phone numbers for principals on their behalf.</li></ul>';
